import { TRIP_REQUIRED_FIELD_OPTION_VALUES } from './PayerSpecificSettings/PayerTripRequiredFieldSettings/tripRequiredFieldOptions';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';


export const payerRequiredTripFieldOptionToValue = (option: SelectOption) => {
  if (option.value === TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT) {
    return null;
  }

  return option.value === TRIP_REQUIRED_FIELD_OPTION_VALUES.YES;
};
